import React from "react";
import {
  Dashboard
} from "../../_websoc/_partials";

export function DashboardPage() {
  return <Dashboard />;
}
